//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/colors/red.js
var e = {
	50: "#ffebee",
	100: "#ffcdd2",
	200: "#ef9a9a",
	300: "#e57373",
	400: "#ef5350",
	500: "#f44336",
	600: "#e53935",
	700: "#d32f2f",
	800: "#c62828",
	900: "#b71c1c",
	A100: "#ff8a80",
	A200: "#ff5252",
	A400: "#ff1744",
	A700: "#d50000"
};
//#endregion
export { e as default };

//# sourceMappingURL=index84.js.map